import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "team",
  "use": "team-usage",
  "viewBox": "0 0 140 140",
  "content": "<symbol viewBox=\"0 0 140 140\" xmlns=\"http://www.w3.org/2000/svg\" id=\"team\">\n    <path d=\"M95.281 84.547l6.958-7.455 4.458 4.776-8.067 8.643L112 104.836 105.314 112l-13.37-14.325-8.07 8.646-4.452-4.779 6.955-7.455L37.94 42.19 33.6 28l13.247 4.644 48.434 51.9v.003z\" />\n    <path d=\"M53.62 94.09l6.96 7.455-4.457 4.776-8.067-8.646L34.686 112 28 104.839l13.37-14.325-8.067-8.646 4.458-4.776 6.958 7.455 48.434-51.9L106.4 28l-4.334 14.193L53.62 94.09z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol